<template>
  <div class="toggle">
    <div
      data-action="ratio_quarter"
      class="btn cursor-pointer"
      :class="{select:checkSelected(1)}"
      @click="selectBtn()"
    >{{text1}}</div>

    <div
      data-action="ratio_year"
      class="btn cursor-pointer"
      :class="{select:checkSelected(2)}"
      @click="selectBtn()"
    >{{text2}}</div>
  </div>
</template>

<script>
export default {
  name: "two-toggle",
  props: {
    // Props to receive
    // text1 ( type: string, required: false, description: 'String for left hand side button')
    // text2 ( type: string, required: false, description: 'String for right hand side button')
    // select ( type: Number, required: false, description: 'Pointer of selection')
    // selectFn ( type: Function, required: false, description: 'Function to be invoked when change toggle')
    text1: {
      type: String,
      default: "ไตรมาส"
    },
    text2: {
      type: String,
      default: "ปี"
    },
    select: {
      type: Number,
      default: 2
    },
    selectFunction: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    selectBtn() {
      if (this.select === 1) {
        this.selectFunction(2);
      } else {
        this.selectFunction(1);
      }
    },
    checkSelected(index) {
      return this.select === index;
    }
  }
};
</script>

<style lang='scss' scoped>
.toggle {
  background-color: $finno-orange;
  width: 129px;
  height: 30px;
  border-radius: 15px;
  // display: inline;
  // border-radius: 15px;
  padding: 0px 4px;
  display: flex;
  .btn {
    color: $color-normal-text;
    font-family: DBHeaventRez;
    font-size: 12px;
    font-weight: bold;
    padding: 2px 7px;
    min-width: 62px;
    text-align: center;
    // width: 64px;
    height: 24px;
    margin-top: 3px;

    &.select {
      color: $black;
      background-color: white;
      border-radius: 15px;
    }

    &:nth-child(2) {
      margin-left: -2px;
    }
  }
}
</style>
